import React from "react";
import { Link } from "react-router-dom";

import homeImage from "../assets/home-about.png";
import { ArrowIcon } from "./Icons";

function AboutHomeSection() {
  return (
    <section className="about-home-section">
      <div className="about-home-grid">
        {/* LEFT – TEXT */}
        <div className="about-home-text">
          <span className="about-home-kicker">About Expert Finance</span>
          <h2 className="about-home-title">Mortgages and insurance you can actually follow</h2>

          <p className="about-home-lead">
            Most people sign a home loan or take out cover once, then never look
            at it again. We’d rather you knew what you were agreeing to. That
            means going through the loan offer and the policy with you, in
            normal language, before anything gets signed.
          </p>

          <div className="about-home-points">
            <div className="about-home-point">
              <span className="about-home-point-number">01</span>
              <div>
                <h3>Plain explanations</h3>
                <p>
                  Loan agreements and policy documents are written by lawyers,
                  for lawyers. We read them so you don’t have to, then tell you
                  what the fees, break costs and exclusions mean for you.
                </p>
              </div>
            </div>

            <div className="about-home-point">
              <span className="about-home-point-number">02</span>
              <div>
                <h3>Lender and insurer comparisons</h3>
                <p>
                  We put home loans from different banks, and cover from
                  different insurers, side by side and show you where they part
                  ways. The lowest rate or the cheapest premium is sometimes the
                  right call. Sometimes it costs you more further down the
                  track.
                </p>
              </div>
            </div>

            <div className="about-home-point">
              <span className="about-home-point-number">03</span>
              <div>
                <h3>Built around your situation</h3>
                <p>
                  A first home buyer and a family growing a property portfolio
                  need very different things. We look at your income, deposit and
                  plans, then structure the loan and the cover that protects it
                  around that.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT – IMAGE + CTA */}
        <div className="about-home-card">
          <div className="about-home-photo">
            <img src={homeImage} alt="Home loan and insurance advice" />
          </div>

          <div className="about-home-stat">
            <span className="about-home-stat-number">
              Start with a conversation
            </span>
            <span className="about-home-stat-label">
              We’ll go through the options before you commit to anything
            </span>
            <Link to="/contact" className="pill-btn pill-btn-primary">
              Book a free chat
              <ArrowIcon />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutHomeSection;  